import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import HistoryRow, { GRID_COLUMNS } from './HistoryRow';

const TableContainer = styled.div`
  background: var(--if-surface-1);
  border: 1px solid var(--if-border);
  border-radius: 6px;
  overflow: hidden;
`;

const HeaderRow = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLUMNS};
  gap: 0;
  padding: 6px 14px;
  background: var(--if-surface-2);
  border-bottom: 1px solid var(--if-border);
`;

const HeaderCell = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: var(--if-ink-3);
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const EmptyRow = styled.div`
  padding: 40px;
  text-align: center;
  color: var(--if-ink-3);
  font-size: 13px;
`;

export default function HistoryTable({ rows, expandedRows, onToggleRow }) {
  if (rows.length === 0) {
    return (
      <TableContainer>
        <EmptyRow>No changes match your filters.</EmptyRow>
      </TableContainer>
    );
  }

  return (
    <TableContainer>
      <HeaderRow>
        <HeaderCell>Timestamp</HeaderCell>
        <HeaderCell>User</HeaderCell>
        <HeaderCell>Field</HeaderCell>
        <HeaderCell>Before &rarr; After</HeaderCell>
        <HeaderCell>Category</HeaderCell>
        <HeaderCell />
      </HeaderRow>
      {rows.map((row, index) => {
        const rowKey = `${row.sessionIndex}-${row.changeIndex}`;
        const isExpanded = expandedRows.includes(rowKey);
        const showSessionBorder =
          index > 0 && row.sessionIndex !== rows[index - 1].sessionIndex;

        return (
          <HistoryRow
            key={rowKey}
            row={row}
            isExpanded={isExpanded}
            showSessionBorder={showSessionBorder}
            isEven={index % 2 === 0}
            onToggle={() => onToggleRow(rowKey)}
          />
        );
      })}
    </TableContainer>
  );
}

HistoryTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      sessionIndex: PropTypes.number,
      changeIndex: PropTypes.number,
    }),
  ).isRequired,
  expandedRows: PropTypes.arrayOf(PropTypes.string).isRequired,
  onToggleRow: PropTypes.func.isRequired,
};
